import React from 'react';

interface HoneypotFieldProps {
  value: string;
  onChange: (value: string) => void;
  fieldName?: string;
}

export const HoneypotField: React.FC<HoneypotFieldProps> = ({
  value,
  onChange,
  fieldName = 'website_url',
}) => {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        opacity: 0,
        pointerEvents: 'none',
      }}
    >
      <label htmlFor={fieldName}>
        Leave this field empty
      </label>
      <input
        type="text"
        id={fieldName}
        name={fieldName}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        tabIndex={-1}
        autoComplete="off"
      />
    </div>
  );
};

export function isHoneypotTriggered(value: string): boolean {
  return value.length > 0;
}
